export default __webpack_public_path__ + "static/media/planer.9f9b10d8.png";